<app-code-reader-base>
  <!-- back button -->
  <div class="relative size-full">
    <video #qrReader class="size-full overflow-hidden bg-neutral-800 object-cover"></video>
    <div class="absolute top-1/2 left-1/2 -translate-1/2 rounded-3xl border-[12px] border-dashed border-white">
      <img src="assets\woordkr8\sprites\qr-code.png" class="opacity-50" />
    </div>
  </div>
  <button (click)="close()" class="absolute top-0 left-4 w-48 transition-transform hover:scale-105" type="button">
    <img src="assets\woordkr8\sprites\back-button.png" class="object-contain" alt="Terug" />
  </button>
</app-code-reader-base>
